import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ProductCardImage from 'components/consumer/product-card/ProductCardPhoto/ProductCardImage';
import ProductCardImageComingSoon from './ProductCardImageComingSoon';
const ProductCardConfigImage = t0 => {
  const $ = _c(6);
  const {
    disableImageLazyLoading,
    prioritizeImage,
    image,
    isFlipped: t1
  } = t0;
  const isFlipped = t1 === undefined ? false : t1;
  if (!image) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ProductCardImageComingSoon />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  const t2 = disableImageLazyLoading ? false : undefined;
  let t3;
  if ($[1] !== image || $[2] !== isFlipped || $[3] !== prioritizeImage || $[4] !== t2) {
    t3 = <ProductCardImage customImg={image} displayOptionImages={false} hasPreLoad={false} imageClassName="!object-contain w-[80%] h-[70%] m-[1.25rem]" imageLoaded={false} layout="category" lazy={t2} priority={prioritizeImage} productCategory="" productImageOptionTypeId={null} setLazy={false} trimCustomImage={true} isFlipped={isFlipped} />;
    $[1] = image;
    $[2] = isFlipped;
    $[3] = prioritizeImage;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
ProductCardConfigImage.propTypes = {
  disableImageLazyLoading: PropTypes.bool,
  prioritizeImage: PropTypes.bool,
  image: PropTypes.string,
  isFlipped: PropTypes.bool
};
export default ProductCardConfigImage;